import React from "react";
import Slider from "react-slick";
import Card2 from "../../TestimonialCard/Card2/index";
import { placementsData } from "./data";

import "./styles.scss";

function Recruiters() {
  const settings = {
    prevArrow: (
      <button type="button" className="carousal-btn">
        <img
          src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y16fv8m1oz6b1e.png"
          alt="move-left"
          loading="lazy"
        />
      </button>
    ),
    nextArrow: (
      <button type="button" data-role="none" className="carousal-btn">
        <img
          src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y16fv8m1oz7enr.png"
          alt="move-left"
          loading="lazy"
        />
      </button>
    ),
    dots: true,
    infinite: true,
    speed: 1000,
    autoplaySpeed: 4000,
    fadeIn: false,
    autoplay: false,
    pauseOnHover: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 805,
        settings: {
          slidesToShow: 1,
          variableWidth: false,
          centerMode: false,
        },
      },
    ],
  };

  return (
    <React.Fragment>
      <div className="mlp-main-placements-home home-placement recruiters">
        <div className="placements-container">
          <div className="placement-slider">
            <h3 className="header">
              Hear From <span className="sub-title"> our Recruiters </span>
            </h3>

            <Slider {...settings}>
              {placementsData.map((info, key) => (
                <Card2
                  key={key}
                  image={info.image}
                  name={info.name}
                  company={info.company}
                  description={info.description}
                  extraText={info.extra_text ? info.extra_text : ""}
                />
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Recruiters;
